import React from 'react';
import '../styles/Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';


function Footer() {
  return (
    <div className='footer'>
      <div>
        <img src='acm_logo.jpeg' alt='acm_logo' className='acm_logo'/>
        <p className='footer-header header-one'>SNDT ACM-W STUDENT CHAPTER</p>
        <p className='footer-header sub-header-one'>Usha Mittal Institute Of Technology</p>
        <p className='footer-header sub-header-one'>SNDT Women's University Santacruz(W) Mumbai - 400049</p>

        <div className='icons'>
      <a
        href="https://www.instagram.com/sndt_acm/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faInstagram} color="#fdfcfcff" />
      </a>
      <a
        href="https://www.linkedin.com/company/sndt-acm-w-student-chapter/posts/?feedView=all"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faLinkedin} color="#edf0f3ff" />
      </a>
    </div>

        <p className='sub-header-two footer-header'> © Copyright SNDT ACM-W Student Chapter</p>
      </div>
        
      
    </div>
  )
}

export default Footer;